module.exports = __webpack_public_path__ + "static/media/defaultFooter.38bcc3bf.jpg";